<template>
  <Content id="institutions">
    <div slot="search">
      <Search :model="search" :elem="searchElem" :btn-loading="list.loading" @on-search="handleDataList" />
    </div>
    <!-- Search -->
    <div slot="extra">
      <Button icon="md-add" @click="handleCreate" type="primary">添加</Button>
    </div>
    <!-- .toolbar -->
    <ITable ref="list" stripe :columns="columns" :loading="list.loading" :data="list.data" :total="list.total"
      @on-page-change="handleDataList" @on-selection-change="handleSelectionChange" />
    <!-- ITable -->
    <InstitutionEdit ref="edit" @on-update="handleDataList" />
    <!-- InstitutionEdit -->
  </Content>
</template>
<script>
import {
  _delInstitution, // 删除
  _getInstitutionList // 列表
} from "@/services/manage/institutions";
import InstitutionEdit from "./InstitutionEdit";
export default {
  name: "Institutions",
  components: {
    InstitutionEdit
  },
  data() {
    return {
      // 表单数据
      search: {
        name: "",
        labels: "",
      },
      // 列表属性
      list: {
        data: [], // 结构化数据
        total: 0, // 数据总数
        loading: false // 加载状态
      },
      // 表单元素
      searchElem: [
        {
          label: '机构名称',
          prop: "name",
          labelWidth: 80,
          placeholder: ""
        },
        {
          label: '子机构名称',
          prop: "subordinate",
          labelWidth: 100,
          placeholder: ""
        },
        {
          label: '标识',
          prop: "labels",
          labelWidth: 50,
          placeholder: ""
        },
      ],
      // 表格列的配置描述
      columns: [
        {
          title: '机构id',
          key: "id",
          minWidth: 80,
          visible: true,
        },
        {
          title: "机构名称",
          key: "name",
          minWidth: 200,
          visible: true,
        },
        {
          title: "子机构名称",
          key: "subordinate",
          minWidth: 200,
          visible: true,
        },
        {
          title: "标识",
          key: "labels",
          minWidth: 70
        },
        {
          title: "责任医生",
          key: "doctor",
          minWidth: 100
        },
        // {
        //   title: "家庭医生",
        //   key: "familyDoctor",
        //   minWidth: 100
        // },
        {
          title: "模板",
          key: "analysisTemplateName",
          minWidth: 80,
        },
        {
          title: "街道",
          key: "streetCodeName",
          minWidth: 100,
        },
        {
          title: "客户代码",
          key: "customerCode",
          minWidth: 100,
        },
        {
          title: "联系电话",
          key: "phone",
          minWidth: 130,
        },
        {
          title: "联系地址",
          key: "address",
          minWidth: 250,
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          fixed: "right",
          minWidth: 150,
          render: (h, params) => this.$Utils.operatorBtn_FORMAT(h,params,
            {
              type: 'edit',
              confirm: false,
              callback: this.handleEdit
            },
            {
              type: 'delete',
              confirm: true,
              callback: this.handleRemove
            }
          )
        }
      ]
    };
  },
  mounted() {
    this.handleDataList(); // 获取列表数据
  },
  methods: {
    /**
     * 获取用户列表
     * @param  {string} type 是否使用搜索, 默认值 undefined (不使用搜索)
     */
    handleDataList(type) {
      if (this.search.labels && this.search.labels.match(/[^\d]+/g)){
        this.$message.warning("标识只能为数字")
        return;
      }

      this.$Loading.start();
      this.list.loading = true; // 列表加载状态
      const page = this.$refs["list"].handlePage(type); // 获取分页信息
      // 模拟异步请求(搜索)
      setTimeout(() => {
        _getInstitutionList({
          ...this.search,
          currentPage: page.current,
          pageSize: page.pageSize
        }).then(res => {
            this.$Loading.finish();
            if (res.errcode == 1){
              const { records, total } = res.data;
              this.list = {
                data: records,
                total: total,
                loading: false
              };
            } else {
              this.$message.error(res.errmsg)
              this.list = {
                data: [],
                total: 0,
                loading: false
              };
            }
          }).catch(() => {
            this.$Loading.error();
            this.list.loading = false;
          });
      }, 500);
    },
    // 新增界面
    handleCreate() {
      this.$refs["edit"].handleModal("新增机构"); // 显示创建模态框
    },
    /**
     * 编辑界面
     * @param  {object} row 当前行数据
     */
    handleEdit(row) {
      this.$refs["edit"].handleModal("编辑机构", row); // 显示编辑模态框
    },
    /**
     * 删除用户
     * @param  {object} row 当前行数据
     */
    handleRemove(row) {
      this.$Loading.start();
      this.list.loading = true;
      // 模拟异步请求(删除)
      setTimeout(() => {
        _delInstitution({
          id: row.id
        })
          .then(res => {
            if (res.errcode == 1){
              this.$message.success("删除成功")
              this.handleDataList();
            } else{
              this.$message.error(res.errmsg);
            }
          })
          .catch(() => {
            this.$Loading.error();
            this.list.loading = false;
          });
      }, 500);
    },
    /**
     * 在多选模式下有效，只要选中项发生变化时就会触发
     * @param  {array} selection 已选项数据
     */
    handleSelectionChange(selection) {
      const ids = [];
      for (const item of selection) {
        ids.push(item["id"]);
      }
      this.toolbar = {
        ids: ids,
        number: selection.length
      };
    },
  }
};
</script>
<style lang="postcss" scoped>
.toolbar {
  margin-bottom: 24px;
  text-align: right;

  & .number {
    margin-right: 8px;
  }
}
</style>
